import React, { lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
// Header e Footer carregam sob demanda: a LP (/cortesia) não usa e ganha um pacote inicial bem menor.
const Header = lazy(() => import('./Header'));
const Footer = lazy(() => import('./Footer'));
// import WhatsAppButton from './WhatsAppButton';

const ADMIN_ROUTES = ['/admin', '/vendedor'];

const PublicLayout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = ADMIN_ROUTES.some((r) => location.pathname.startsWith(r));
  const isLoginRoute = location.pathname === '/login' || location.pathname === '/solicitar-reserva';
  // LP de captação tem cabeçalho e rodapé próprios
  const isLpRoute = location.pathname === '/cortesia' || location.pathname === '/cortesia/' || location.pathname === '/cortesia/confirmacao'
    || location.pathname.startsWith('/assinar/') || location.pathname.startsWith('/cadastro/');

  if (isAdminRoute || isLoginRoute || isLpRoute) {
    return <>{children}</>;
  }

  return (
    <>
      <Suspense fallback={null}><Header /></Suspense>
      <main className="min-h-screen">{children}</main>
      <Suspense fallback={null}><Footer /></Suspense>
      {/* <WhatsAppButton /> */}
    </>
  );
};

export default PublicLayout;
